const table = [
    {
        id: 1,
        college:"Michigan State University",
        email:"socialmedia@4mich.org",
        full_name:"MSU-For Michigan",
        username:"spartans4mich",
        password:"YNBtLP0ZAH4cDBQsL7ct",
        organizer:"Rylan",
        phone:"3139496420",
        profile:'https://www.instagram.com/spartans4mich/',
        img:'msu'
    },
    {
        id: 2,
        college:"Saginaw Valley State University",
        email:"allison@4mich.org",
        full_name:"SVSU-For Michigan",
        username:"cards4mich",
        password:"5LCbu9v8CmfQDU6GbMC3",
        organizer:"Allison",
        phone:"3034344366",
        profile:'https://www.instagram.com/cards4mich/',
        img:'svsu'
    },
    {
        id: 3, 
        college:'Jackson College',
        email: "rylan@4mich.org",
        full_name:'JC-For Michigan',
        username:"jets4mich",
        password: "8zJ9pk92CC7tmcMCWHAq",
        organizer:'Stanley B.',
        phone:'6618054511',
        profile:'https://www.instagram.com/jets4mich/',
        img:'jc'
    },
    {
        id:4,
        college:'Lansing Community College',
        email:'jjandro@4mich.org',
        full_name:'LCC-For Michigan',	
        username:'lcc4mich',
        password:'F1zD2nbUxpMQZJD47TM9',
        organizer:'James J.',
        phone:'3139496420',
        profile:'https://www.instagram.com/lcc4mich/',
        img:'lcc'
    },
    {
        id:5,
        college:"Western Michigan University",
        email:'shyman@4mich.org',
        full_name:'WMU-For Michigan',
        username:'broncos4mich',
        password:'KFN3dnXJT4u8ZuYzg7Wa',
        organizer:'Seth and Olivia',
        phone:'3139496420',
        profile:'https://www.instagram.com/broncos4mich/',
        img:'wmu'
    },
    {
        id:6,
        college:'Kalamazoo College',
        email:'patrick@4mich.org',
        full_name:'KCollege For Michigan',
        username:'hornets4mich',
        password:'Mep6QWQqavzKFJLCWt1G',
        organizer:'Patrick',
        phone:'2692520945',
        profile:'https://www.instagram.com/hornets4mich/',
        img:'kc'
    },
    {
        id:7,
        college:'Kalamazoo Valley Community College',
        email:'tyler@4mich.org',
        full_name:'KVCC-For Michigan',
        username:'cougars4mich',
        password:'L2436Gd5cxfUcxULXuML',
        organizer:'Tyler',
        phone:'6162047372',
        profile:'https://www.instagram.com/cougars4mich/',
        img:'kvcc'
    },
    {
        id:8,
        college:'Central Michigan University',
        email:"dtrondle@4mich.org",
        full_name:"CMU-For Michigan",
        username:"chips4mich",
        password:"DEQrfcPJrRFN5rvRgPD5",
        organizer:'Dominique',
        phone:'9898024699',
        profile:'https://www.instagram.com/chips4mich/',
        img:'cmu'
    },
    {
        id:9,
        college:'Mid Michigan College',
        email:'dominiquetrondle@gmail.com',
        full_name:'Mid-Mich-For Michigan',
        username:'mid4mich',
        password:'gZs5ckdR7Ea7bXCg8Hq7',
        organizer:'Dominique',
        phone:'9898024699',
        profile:'https://www.instagram.com/mid4mich/',
        img:'mid'
    },
    {
        id:10,
        college:'University of Michigan - Ann Arbor',
        email:'sbiddala@umich.edu',
        full_name:'UMich-For Michigan',
        username:'wolverines4mich',
        password:'UKH2bW1Ft5t5yqHrQxxL',
        organizer:'Hannah',
        phone:'3034344366',
        profile:'https://www.instagram.com/wolverines4mich/',
        img:'umich'
    },
    {
        id:11,
        college:'Delta College',
        email:'bhosler@umich.edu',
        full_name:'Delta-For Michigan',
        username:'deltaducks_4michigan',
        password:'DeltaDucks35',
        organizer:'Allison',
        phone:'2313295940',
        profile:'https://www.instagram.com/deltaducks_4michigan/',
        img:'delt'
    },
    {
        id:12,
        college:'Oakland University',
        email:'Not Available',
        full_name:'OU-For Michigan',
        username:'goldengrizzlies4mich',
        password:'Ztek2522!',
        organizer:'Emma and Stanley I.',
        phone:'Not Available',
        profile:'https://www.instagram.com/grizzilies4mich/',
        img:'ou'
    },
    {
        id:13,
        college:'Lawerence Technological University',
        email:'Not Available',
        full_name:'For Michigan at Lawerence Tech',
        username:'bluedevils4mich',
        password:'ltu2024election',
        organizer:'Andrew',
        phone:'Not Available',
        profile:'https://www.instagram.com/bluedevils4mich/',
        img:'ltu'
    },
    {
        id:14,
        college:'Macomb Community College',
        email:'Not Available',
        full_name:'For Michigan at Macomb Community College',
        username:'monarchs4mich',
        password:'mccelection2024',
        organizer:'Andrew',
        phone:'Not Available',
        profile:'https://www.instagram.com/monarchs4mich/',
        img:'mcc'
    },
    {
        id:15,
        college:'Wayne State University',
        email:'Not Available',
        full_name:'For Michigan at Wayne State University',
        username:'warriors4mich',
        password:'Letsvotewayne43!',
        organizer:'Adam',
        phone:'Not Available',
        profile:'https://www.instagram.com/warriors4mich/',
        img:'wsu'
    },
    {
        id:16,
        college:'University of Michigan - Flint',
        email:'Not Available',
        full_name:'UMich Flint- For Michigan',
        username:'flintwolverines4mich',
        password:'ILY4mich',
        organizer:'Kaitlyn',
        phone:'Not Available',
        profile:'https://www.instagram.com/flintwolverines4mich/',
        img:'umich'
    },
    {
        id:17,
        college:'Mott Community College',
        email:'Not Available',
        full_name:'Mott- For Michigan',
        username:'bears4mich',
        password:'ILY4mich',
        organizer:'Kaitlyn',
        phone:'Not Available',
        profile:'https://www.instagram.com/bears4mich/',
        img:'mocc'
    },
    {
        id:18,
        college:'Kettering University',
        email:'Not Available',
        full_name:'Kettering- For Michigan',
        username:'bulldogs4mich',
        password:'ILY4mich',
        organizer:'Kaitlyn',
        phone:'Not Available',
        profile:'https://www.instagram.com/bulldogs4mich/',
        img:'ket'
    },
    {
        id:19,
        college:'University of Detriot Mercy',
        email:'Not Available',
        full_name:'Not Available',
        username:'titans4mich',
        password:'Titansgotothepolls37',
        organizer:'Adam',
        phone:'Not Available',
        profile:'https://www.instagram.com/titans4mich/',
        img:'udm'
    },
    {
        id:20,
        college:'Grand Valley State University',
        email:'Not Available',
        full_name:'Not Available',
        username:'lakers4mich',
        password:'SpEq2jan',
        organizer:'Alex',
        phone:'Not Available',
        profile:'https://www.instagram.com/lakers4mich/',
        img:'gvsu'
    },
    {
        id:21,
        college:'Eastern Michigan University',
        email:'Not Available',
        full_name:'Not Available',
        username:'eagles4mich',
        password:'GoVote123',
        organizer:'Sole',
        phone:'Not Available',
        profile:'https://www.instagram.com/eagles4mich/',
        img:'emu'
    },
    {
        id:22,
        college:'Madonna University',
        email:'Not Available',
        full_name:'Madonna Crusaders For Michigan',
        username:'crusaders4mich',
        password:'Madonn@4Michigan',
        organizer:'Lauren',
        phone:'Not Available',
        profile:'https://www.instagram.com/crusaders4mich/',
        img:'mad'
    },
    {
        id:23,
        college:'Schoolcraft College',
        email:'Not Available',
        full_name:'Schoolcraft College For Michigan',
        username:'ocelots4mich',
        password:'MichiganFor@Schoolcraft',
        organizer:'Lauren',
        phone:'Not Available',
        profile:'https://www.instagram.com/ocelots4mich/',
        img:'sch'
    },
    {
        id:24,
        college:'Ferris State University',
        email:'Not Available',
        full_name:'Ferris State-For Michigan',
        username:'bulldogs_4mich',
        password:'Jul200024mich109!!',
        organizer:'Mariah',
        phone:'Not Available',
        profile:'https://www.instagram.com/bulldogs_4mich/',
        img:'fsu'
    },
    {
        id:25,
        college:'Albion College',
        email:'Not Available',
        full_name:'Albion - For Michigan',
        username:'britons4mich',
        password:'Not Available',
        organizer:'Not Available',
        phone:'Not Available',
        profile:'https://www.instagram.com/britons4mich/',
        img:'alb'
    },
    {
        id:26,
        college:'Oakland Community College',
        email:'Not Available',
        full_name:'4Mich',
        username:'owls4mich',
        password:'44243harsdale',
        organizer:'Stanley',
        phone:'Not Available',
        profile:'https://www.instagram.com/owls4mich/',
        img:'occ'
    }, 
    {
        id:27,
        college:'Aquinas College',
        email:'Not Available',
        full_name:'Not Available',
        username:'saints4mich',
        password:'S4M2303',
        organizer:'Olivia',
        phone:'Not Available',
        profile:'https://www.instagram.com/saints4mich/',
        img:'occ'
    },
    {
        id:28,
        college:'Michigan Technological University',
        email:'Not Available',
        full_name:'Not Available',
        username:'huskies4mich',
        password:'jozqym-3qAhgy-bydhox',
        organizer:'Evan',
        phone:'Not Available',
        profile:'https://www.instagram.com/huskies4mich/',
        img:'mtu'
    },
    {
        id:29,
        college:'Monroe County Community College',
        email:'Not Available',
        full_name:'Not Available',
        username:'huskies4michigan',
        password:'GoVote123',
        organizer:'Naomi',
        phone:'Not Available',
        profile:'https://www.instagram.com/huskies4michigan/',
        img:'mccc'
    }, 
    {
        id:30,
        college:'Alma College',
        email:'Not Available',
        full_name:'Not Available',
        username:'scots4mich',
        password:'AlmaScots4Mich',
        organizer:'Dominique',
        phone:'Not Available',
        profile:'https://www.instagram.com/scots4mich/',
        img:'alm'
    }


];

//iffy on organizer
//if not available italize

export function logInInfo(college_in) {
    let colleges = table.filter(row => row.college === college_in);
    if (colleges.length === 0) {
        let error = new Error(`404: ${college_in} is not a college with an account created.`);
        error.code = 404;
        throw error;
    }
    let jsonStaffProfile = JSON.stringify(colleges);
    return jsonStaffProfile;
}
